import styled, { css } from 'vue-styled-components';

const InputNumberUnit = (unit) => {
  return css`&::after {
    content: '${unit}';
    position: absolute;
    pointer-events: none;
    width: fit-content;
    height: 10px;
    z-index: 10;
    right: 5px;
    top: 9px;
    font-size: 12px;
    color: #A5A5A5;
    margin-left: 5px;
  }`
}

const InputNumberWrapperUnitProps = { unit: String, width: Number }

const InputNumberWrapper = styled('div', InputNumberWrapperUnitProps)`
  position: relative;
  ${props => `width: ${props.width}px;`}
  height: 32px;
  ${props => InputNumberUnit(props.unit)}
`
export {
  InputNumberWrapper
}